import moment from 'moment'

export default function DATE( value, format ) {
  if ( ! value ) return null

  return moment( value, format ).format( format )
}
